import { Controller } from "@hotwired/stimulus";

// Keeps the filter-chip counts in sync when a project card on the page
// transitions status (draft -> rendering -> completed/failed), without a
// full page reload. Fed by project-status:statusChanged events dispatched
// from project_status_controller.js.
export default class extends Controller {
  static targets = ["count"];

  connect() {
    this.onStatusChanged = this.onStatusChanged.bind(this);
    window.addEventListener("project-status:statusChanged", this.onStatusChanged);
  }

  disconnect() {
    window.removeEventListener("project-status:statusChanged", this.onStatusChanged);
  }

  onStatusChanged(event) {
    const { previous, next } = event.detail;
    this.#adjust(previous, -1);
    this.#adjust(next, 1);
  }

  #adjust(status, delta) {
    const target = this.countTargets.find((el) => el.dataset.status === status);
    if (!target) return;

    const value = Math.max(0, parseInt(target.textContent, 10) + delta);
    target.textContent = value;
    target.hidden = value === 0;
  }
}
